import styled, { css } from 'styled-components';

export const ContentOuterContainer = styled.div(
  ({ theme }) => css`
    background: ${theme.co.primary98};
    min-height: 100dvh;
  `,
);

export const ContentInnerContainer = styled.div(
  ({ theme }) => css`
    background: ${theme.co.primary98};
    min-height: 100dvh;
    max-height: ${theme.sz.xxl};
    max-width: ${theme.sz.s};
    padding: ${theme.sz.s6};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: auto;

    @media (max-width: ${theme.sz.s}) {
      padding: ${theme.sz.s4};
    }
  `,
);

export const Image = styled.img(
  ({ theme }) => css`
    width: ${theme.sz.s74};
    height: auto;
    margin-bottom: ${theme.sz.s6};
  `,
);

export const Title = styled.h1(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.m};
    color: ${theme.co.secondary0};
    text-align: center;
    margin: ${theme.sz.s0} ${theme.sz.s0} ${theme.sz.s4};
  `,
);

export const Description = styled.p(
  ({ theme }) => css`
    ${theme.typography.paragraph.base};
    color: ${theme.co.secondary20};
    text-align: center;
    margin: ${theme.sz.s0} ${theme.sz.s0} ${theme.sz.s6};
  `,
);

export const ButtonContainer = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: ${theme.sz.s4};
  `,
);
